import { render, staticRenderFns } from "./ReportEntity.vue?vue&type=template&id=2145281e&scoped=true&"
import script from "./ReportEntity.vue?vue&type=script&lang=js&"
export * from "./ReportEntity.vue?vue&type=script&lang=js&"
import style0 from "./ReportEntity.vue?vue&type=style&index=0&id=2145281e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145281e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2145281e')) {
      api.createRecord('2145281e', component.options)
    } else {
      api.reload('2145281e', component.options)
    }
    module.hot.accept("./ReportEntity.vue?vue&type=template&id=2145281e&scoped=true&", function () {
      api.rerender('2145281e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportEntity.vue"
export default component.exports